function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M85.959 23.273L56.885 38.415v16.593L40.71 46.62 11.636 61.762v42.965h12.899V69.741l16.175-8.288v43.274h29.073V46.393l16.176-8.367v66.701h30.405V38.946L85.959 23.273z",
  fill: "#fff"
});

function SvgLogoSoloLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLogoSoloLight;